var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sparkline',{ref:_vm.getId,staticClass:"sparkline-updates-trend",attrs:{"lineCap":"round","type":'trend',"value":_vm.getSparklineData,"smooth":10,"label-size":15,"color":'success',"gradient":_vm.getGradient,"gradient-direction":'bottom'}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-625837e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Charts/Profile/trendChanges.vue
// module id = null
// module chunks = 